export default __webpack_public_path__ + "static/media/sun.c250aaea.png";